function isNull(value) {
  return value === null;
}
function isNotNull(value) {
  return value !== null;
}
function isUndefined(value) {
  return value === void 0;
}
function isDefined(value) {
  return value !== void 0;
}
function isNotNullish(value) {
  return value != null;
}
function isBoolean(value) {
  return typeof value === "boolean";
}
function isTrue(value) {
  return value === true;
}
function isFalse(value) {
  return value === false;
}
function isString(value) {
  return typeof value === "string";
}
function isSlugString(value) {
  return isNonEmptyString(value) && /^[a-z0-9_-]+$/.test(value);
}
function isSingleWordString(value) {
  return isNonEmptyString(value) && value.indexOf(" ") === -1;
}
function isNonEmptyString(value) {
  return isString(value) && value.length > 0;
}
function isNonEmptyTrimmedStringFactory(trim = "trim") {
  return function isNonEmptyString2(value) {
    return isString(value) && value[trim]().length > 0;
  };
}
const isNonEmptyTrimmedString = isNonEmptyTrimmedStringFactory();
const isNonEmptyTrimmedStartString = isNonEmptyTrimmedStringFactory("trimStart");
const isNonEmptyTrimmedEndString = isNonEmptyTrimmedStringFactory("trimEnd");
function isNumber(value) {
  return typeof value === "number" && value === value;
}
function isNonNegativeNumber(value) {
  return isNumber(value) && value >= 0;
}
function isNumericString(value) {
  return isString(value) && !isNaN(parseFloat(value));
}
function isOneOfFactory(members) {
  return function isOneOfFactoryProduct(value) {
    return members.includes(value);
  };
}
function satisfiesOneOfFactory(...predicates) {
  return (value) => {
    return predicates.some((predicate) => predicate(value));
  };
}
function isArrayOfMembersSatisfyingFactory(predicate) {
  return function isArrayOfMembersSatisfyingProduct(value) {
    return Array.isArray(value) && value.every(predicate);
  };
}
function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement;
}
function isObject(value) {
  return typeof value === "object" && value !== null;
}
function isPlainObject(value) {
  return isObject(value) && value.constructor === Object;
}
export {
  isArrayOfMembersSatisfyingFactory,
  isBoolean,
  isDefined,
  isFalse,
  isHTMLElement,
  isNonEmptyArray,
  isNonEmptyString,
  isNonEmptyTrimmedEndString,
  isNonEmptyTrimmedStartString,
  isNonEmptyTrimmedString,
  isNonNegativeNumber,
  isNotNull,
  isNotNullish,
  isNull,
  isNumber,
  isNumericString,
  isObject,
  isOneOfFactory,
  isPlainObject,
  isSingleWordString,
  isSlugString,
  isString,
  isTrue,
  isUndefined,
  satisfiesOneOfFactory
};
//# sourceMappingURL=Predicates.js.map
